"use strict";
/**
 * @file Created on Fri Aug 24 2018
 * @author VBr
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Parser_1 = require("../Parser");

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var Validator_1 = require("../Validator");
/**
 * Validator that checkes number's in range
 */


var SelectValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(SelectValidator, _Validator_1$Validato);

  function SelectValidator() {
    var _this;

    _classCallCheck(this, SelectValidator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectValidator).apply(this, arguments));
    _this.stringParser = new Parser_1.StringParser();
    return _this;
  }

  _createClass(SelectValidator, [{
    key: "doValidate",
    value: function doValidate(value) {
      if (!this.stringParser.parse(value, ValidationLevel_1.ValidationLevel.Fast)) {
        return new ValidationResult_1.ValidationError(SelectValidator.INVALID_VALUE_ERROR);
      }

      return new ValidationResult_1.ValidationSuccess(value);
    }
  }]);

  return SelectValidator;
}(Validator_1.Validator);

exports.SelectValidator = SelectValidator;
SelectValidator.INVALID_VALUE_ERROR = 'INVALID_VALUE_ERROR';